import { jsx as e } from "react/jsx-runtime";
import c from "clsx";
import { AspectRatio as l } from "../AspectRatio/AspectRatio.js";
import '../../_assets/SkeletonImage.DglQ-myD.css';const n = "_image_zijar_1", g = {
  image: n
}, x = ({
  width: i,
  height: m,
  aspectRatio: o,
  className: s
}) => /* @__PURE__ */ e(l, { width: i, height: m, aspectRatio: o, className: s, children: ({ style: a, containerClassName: t, childClassName: r }) => /* @__PURE__ */ e("div", { style: a, className: t, children: /* @__PURE__ */ e("div", { className: c(g.image, r) }) }) });
export {
  x as SkeletonImage
};
